import React, { Fragment } from 'react';
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { capitalize, displayCash, displayPosition, getDateText, getNameFromEmail, showDateTimeFromString } from '../utils/utils';
import FilterListIcon from '@mui/icons-material/FilterList';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
}))(TableCell);

const StyledTableSortLabel = withStyles((theme) => ({
    root: {
      color: theme.palette.common.white + ' !important',
    },
    icon: {
        color: theme.palette.common.white + ' !important',
    },
    iconDirectionAsc:{
        transform: 'rotate(0deg)'
    },
    iconDirectionDesc:{
        transform: 'rotate(180deg)'
    },
}))(TableSortLabel);
  
const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
      /*'&.checkIn':{
        backgroundColor: '#fafa07'
      },
      '&.checkIn&:nth-of-type(odd)':{
        backgroundColor: '#e8e801'
      }*/
    },
}))(TableRow);

export default function JSData(props) {
    const data = props.data || []
    const cells = props.cells || []

    const sort = props.sort || {}

    const order = sort.order
    const orderBy = sort.orderBy

    const handleSort = (field) => (event) => {
        let newOrder
        if (orderBy === field && order !== 'asc'){
            newOrder = 'asc'
        } else {
            newOrder = 'desc'
        }

        props.handleSort({order:newOrder, orderBy:field})
    };

    return (        
        <Table stickyHeader size="small">
            <TableHead color='primary'>
                <TableRow>
                    {props.withIndex&&<StyledTableCell
                        style={{minWidth:1, fontWeight: 'bold', borderRight: '1px solid #e0e0e0'}}
                    >
                    </StyledTableCell>}
                    {cells.map(cell => (
                        <Fragment key={cell.key || cell.id}>
                            {(!cell.hidden)&&<StyledTableCell
                                align={cell.align}
                                style={{minWidth:cell.minWidth||10, fontWeight: 'bold', borderRight: '1px solid #e0e0e0'}}
                            >
                                {props.handleSort?
                                <StyledTableSortLabel
                                    active={orderBy === cell.id}
                                    direction={orderBy === cell.id ? order : 'desc'}
                                    onClick={handleSort(cell.id)}
                                >
                                    {cell.label}
                                </StyledTableSortLabel>:
                                <div style={{display: 'flex',justifyContent: 'space-between'}}>
                                    <div>{cell.label}</div>
                                    {cell.filter&&<IconButton size='small' onClick={()=>{props.handleShowFilterColumn(cell.id)}} style={{color:'white', marginLeft: 8}}>
                                        <FilterListIcon fontSize='small'/>
                                    </IconButton>}
                                </div>}
                            </StyledTableCell>}
                        </Fragment>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {props.handleNewRow&&<StyledTableRow> 
                    {props.withIndex&&<TableCell style={{borderRight: '1px solid #e0e0e0'}}>
                        <div onClick={props.handleNewRow} style={{cursor: 'pointer',height: 20}}></div>
                    </TableCell>}
                    {cells.map((cell, index) =>  (
                        <Fragment key={cell.key || cell.id}>
                            {(!cell.hidden)&&<TableCell
                                key={cell.key || cell.id} 
                                align={cell.align} 
                                style={{borderRight: '1px solid #e0e0e0'}}
                                dir="auto"
                            >
                                <div onClick={props.handleNewRow} style={{cursor: 'pointer',height: 20, color: 'blue'}}>+New</div>
                            </TableCell>}
                        </Fragment>
                    ))}
                </StyledTableRow>}
                {data.map((row, rowIndex) => {
                    let rowStyle = {}
                    if (props.rowBackgroundColor && row[props.rowBackgroundColor]){
                        rowStyle.backgroundColor = row[props.rowBackgroundColor]
                    }

                    return (
                    <StyledTableRow key={row._id||rowIndex} style={rowStyle}>
                        {props.withIndex&&<TableCell 
                            style={{whiteSpace: 'pre-line', borderRight: '1px solid #e0e0e0'}}
                        >
                           {rowIndex+1}
                        </TableCell>}
                        {cells.map(cell =>  {
                            let backgroundColor
                            let value = row[cell.id] === undefined ? '' : row[cell.id]
                            let link

                            if(cell.getValue){
                                value = cell.getValue(row)
                            }

                            if(cell.capitalize){
                                value = capitalize(value)
                            }

                            if(cell.hideZero && value === 0){
                                value = ''
                            }

                            if (typeof value === 'number' && !isNaN(value)) {
                                value = Math.round(value * 100) / 100
                            }

                            switch (cell.type){
                                case 'DATE': {
                                    value = showDateTimeFromString(value, false);
                                    break;
                                } case 'BOOLEAN': {
                                    if (cell.noText){
                                        value=''
                                    } else if (cell.emoj) {
                                        value = row[cell.id]?'🔳':'🔲'
                                    } else if(row[cell.id] === undefined){
                                        value = ''
                                    } else {
                                        if (cell.stringIfTrue){
                                            value = row[cell.id]?'V':''
                                        } else {
                                            value = row[cell.id]?'Yes':'No'
                                        }
                                    }

                                    if (row[cell.id] && cell.backgroundColor){
                                        backgroundColor = cell.backgroundColor
                                    }
                                    break;
                                } case 'DATE_TIME': {
                                    value = showDateTimeFromString(value, true);
                                    break;
                                } case 'DATE_TIME_S': {
                                    value = showDateTimeFromString(value, true, false, 'Europe/Belgrade');
                                    break;
                                } case 'CONTACT': {
                                    value = value + (row[cell.phone]?(', ' + row[cell.phone]):'') + (row[cell.email]?(', ' + row[cell.email]):'')
                                    break;
                                } case 'SALARY': {
                                    value = displayCash({value:value, currency:row[cell.curField], frequency:row[cell.freqField]})
                                    break;
                                } case 'NAME_FROM_EMAIL': {
                                    value = getNameFromEmail(value)
                                    break;
                                } case 'CHECKBOX': {
                                    value = value?'Yes':'No'
                                    if (value === 'Yes'){
                                        if (cell.fieldToShow){
                                            value = getNameFromEmail(row[cell.fieldToShow]) || 'Yes'
                                        }
                                        backgroundColor = '#E8F0FE'
                                    }
                                    break;
                                } case 'CYCLES': {
                                    if (!row[cell.fieldToCheck]){
                                        if(cell.fieldAlternative){
                                            value = row[cell.fieldAlternative] || ''
                                        } else {
                                            value = ''
                                        }
                                    }
                                    break;
                                } case 'LINK2': {
                                    if (row[cell.linkField]){
                                        link = row[cell.linkField]
                                        value = row[cell.linkLabelField]
                                    } else if (row[cell.linkLabelField]){
                                        value = row[cell.linkLabelField]
                                    }
                                    break;
                                } default:{
                                    
                                }
                            }
                            return (
                                <Fragment key={cell.key || cell.id}>
                                    {(!cell.hidden)&&<TableCell
                                        key={cell.key || cell.id} 
                                        style={{whiteSpace: 'pre-line', borderRight: '1px solid #e0e0e0', textAlign: 'initial', backgroundColor:backgroundColor}}
                                        dir="auto"
                                    >
                                        {(cell.type === 'WA_PHONE')&&<a href={'https://wa.me/'+value} target="_blank" rel="noopener noreferrer">{cell.linkLabel || value}</a>}
                                        {(cell.type === 'LINK' && value)&&<a href={value} target="_blank" rel="noopener noreferrer">{cell.linkLabel || value}</a>}
                                        {(cell.type === 'LINK2'&&link)&&<a href={link} target="_blank" rel="noopener noreferrer">{value}</a>}
                                        {(!['WA_PHONE', 'LINK', 'LINK2'].includes(cell.type)||(cell.type === 'LINK2'&&!link))&&<>
                                        {(cell.position&&row[cell.position]&&row[cell.position]>1)?<div>
                                            <span onClick={(props.handleEditRow&&!cell.noEdit)?()=>{props.handleEditRow(row, {cell:cell.id, group: cell.group})}:undefined} style={(props.handleEditRow&&!cell.noEdit)?{cursor: 'pointer',minHeight:20}:{}}>{value}</span>
                                            <span onClick={(props.handleEditRow&&!cell.noEdit)?()=>{props.handleEditRow(row, {value:row[cell.id], group: cell.group, position:true})}:undefined} style={(props.handleEditRow&&!cell.noEdit)?{cursor: 'pointer',minHeight:20}:{}}> - <strong>{displayPosition(row[cell.position])}</strong></span>
                                        </div>:
                                        <div onClick={(!props.noEditAll&&props.handleEditRow&&!cell.noEdit&&!cell.actionLabel)?()=>{props.handleEditRow(row, {cell:cell.id, group: cell.group})}:undefined} style={(!props.noEditAll&&props.handleEditRow&&!cell.noEdit)?{cursor: 'pointer',minHeight:20}:{}}>
                                            {value}
                                            {cell.actionLabel&&<span onClick={(props.handleEditRow)?()=>{props.handleEditRow(row, {cell:cell.id, group: cell.group})}:undefined} style={(props.handleEditRow)?{cursor: 'pointer',marginLeft:8, color:'blue'}:{}}>{cell.actionLabel}</span>}
                                            {cell.showTimeAgo&&<span style={{fontSize:12, display:'block', lineHeight:1}}>{getDateText(row[cell.id])}</span>}
                                        </div>}</>}
                                    </TableCell>}
                                </Fragment>
                            )
                        })}
                    </StyledTableRow>
                )})}
            </TableBody>
        </Table>
    )
}